import { REMINDER_TRIGGER_INFORMATION_HIDDEN } from 'helper/const';

export const hideTriggerInformation = triggerName => {
  return REMINDER_TRIGGER_INFORMATION_HIDDEN.includes(triggerName);
};
